<template>
  <div class="login-container">
    <div class="form_container">
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        auto-complete="on"
        label-position="left"
      >
        <div class="title-container">
          <h3 class="title">
            {{ $t("login.title") }}
          </h3>
          <!-- <lang-select class="set-language" /> -->
        </div>

        <el-form-item prop="username">
          <span class="svg-container">
            <svg-icon icon-class="user" />
          </span>
          <el-input
            v-model="loginForm.username"
            :placeholder="$t('login.username')"
            name="username"
            type="text"
            auto-complete="on"
          />
        </el-form-item>

        <el-form-item prop="password">
          <span class="svg-container">
            <svg-icon icon-class="password" />
          </span>
          <el-input
            v-model="loginForm.password"
            :type="passwordType"
            :placeholder="$t('login.password')"
            name="password"
            auto-complete="on"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon
              :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"
            />
          </span>
        </el-form-item>

        <el-button
          :loading="loading"
          type="primary"
          style="
            width: 100%;
            margin-bottom: 30px;
            margin-top: 10px;
            padding: 14px 20px;
          "
          @click.native.prevent="handleLogin"
        >
          登&nbsp;&nbsp;&nbsp;&nbsp;录
        </el-button>
      </el-form>
    </div>

    <div class="login_security">
      <!-- <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2022010694号-1</a> -->
      <img src="../../assets/police.png" alt="">
      <a
        href="https://beian.mps.gov.cn/#/query/webSearch?code=11011302007105\"
        rel="noreferrer"
        target="_blank"
        >京公网安备11011302007105</a
      >
      <a href="https://beian.miit.gov.cn/" target="_blank"
        >京ICP备2022010694号-1</a
      >
    </div>
    <!-- <particles></particles> -->
  </div>
</template>

<script>
import LangSelect from "@/components/LangSelect";
// import Particles from '@/components/Particles/index';
export default {
  name: "Login",
  components: { LangSelect },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码至少6位"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
      },
      passwordType: "password",
      loading: false,
      redirect: undefined,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("LoginByUsername", this.loginForm)
            .then(() => {
              this.loading = false;
              this.$router.push({ path: this.redirect || "/" }, () => {});
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          //   console.log('error submit!!')
          return false;
        }
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #eee;
$cursor: #fff;
$dark_gray: #1c1d1d;

// @supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
//   .login-container .el-input input {
//     color: $cursor;
//     &::first-line {
//       color: $light_gray;
//     }
//   }
// }

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $dark_gray;
      height: 47px;
      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px white inset !important;
        // -webkit-text-fill-color: transparent !important;
      }
    }
  }
  .el-form-item {
    border: 1px solid #d9d8d8;
    margin-bottom: 30px;
    border-radius: 5px;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
// $bg:#2d3a4b;
$bg: transparent;
$dark_gray: #313131;
$light_gray: #eee;
.login-container {
  background: url("~@/assets/login/login_bg.jpg") no-repeat;
  background-size: cover;
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;
  .form_container {
    background: url("~@/assets/login/login_form_bg.png");
    background-size: 100% 100%;
    position: absolute;
    top: 20vh;
    right: 15vw;
    min-height: 420px;
    width: 450px;
    .login-form {
      width: 300px;
      margin: auto;
      margin-top: 65px;
    }
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }
  .title-container {
    position: relative;
    .title {
      font-size: 26px;
      color: #138de3;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
    .set-language {
      color: #fff;
      position: absolute;
      top: 3px;
      font-size: 18px;
      right: 0px;
      cursor: pointer;
    }
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
.login_security {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #989fb0;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  margin-left: 10px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  img {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
  a {
    margin-right: 10px;
  }
  a:hover {
    color: #409eff;
  }
}
</style>
